export default __webpack_public_path__ + "static/char-s-06-jp-e48a1104f0c736d9bc3f9db8bcb99fd2.png";